////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex, isUndefined } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const addItemCatalog = {
	[ActionsTypes.POST_BIND_CATALOG]: (state) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_BIND_CATALOG_SUCCESS]: (state, payload) => {
		let paging = cloneDeep(payload.data.headerContent.contentPagined)
		let items = cloneDeep(payload.data.headerContent.contentPagined.content)
		let filters = cloneDeep(payload.data.headerParam.filters)

		return update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				paging: {
					$set: paging,
				},
				items: {
					$set: items,
				},
				header: {
					$set: filters,
				},
				errorUnlink: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.POST_BIND_CATALOG_FAILURE]: (state, payload) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.PUT_LINK_CATALOG_ITEM]: (state) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: true,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.PUT_LINK_CATALOG_ITEM_SUCCESS]: (state, payload) => {
		const data = cloneDeep(payload.data)
		const stateCp = cloneDeep(state.addItemCatalog.paging.content)

		const idx = findIndex(stateCp, { itemId: data.itemId })
		stateCp[idx] = data
		return update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.PUT_LINK_CATALOG_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.PUT_UNLINK_CATALOG_ITEM]: (state) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.PUT_UNLINK_CATALOG_ITEM_SUCCESS]: (state, payload) => {
		// Test if we have a regular response or an error response
		let errorUnlinkCp = cloneDeep(state.addItemCatalog.errorUnlink)
		if (!isUndefined(payload.data.errorCode)) {
			errorUnlinkCp = payload.data
		} else {
			const data = cloneDeep(payload.data)
			const stateCp = cloneDeep(state.addItemCatalog.paging.content)
			const idx = findIndex(stateCp, { itemId: data.itemId })
			stateCp[idx] = data
		}
		return update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				isUpdated: {
					$set: true,
				},
				errorUnlink: {
					$set: errorUnlinkCp,
				},
			},
		})
	},
	[ActionsTypes.PUT_UNLINK_CATALOG_ITEM_FAILURE]: (state, payload) =>
		update(state, {
			addItemCatalog: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default addItemCatalog
